import {fromJS} from "immutable";
import {ADD_JOB, PACKAGES_DATA, UPDATE_JOB, UPDATE_PACKAGES} from "../actions/WarehousePackageActions";
import {getPackageUID} from "../lib/WarehouseHelper";

const initialState = fromJS({
  status: "not_loaded", // not_loaded, loading, loaded, error
  packages: {},
  jobs: {},
});

const reducer = function(state = initialState, action) {
  const jobsPath = ["jobs", action.warehouseId];
  const packagesPath = ["packages", action.warehouseId];

  switch(action.type) {
    case PACKAGES_DATA.LOAD:
      const loadedState = state
        .setIn(packagesPath, convertServerPackages(action.jobs))
        .setIn(jobsPath, convertServerJobs(action.jobs))
        .set("status", "loaded");
      
      console.log("[REDUCER] INIT JOBS", loadedState.toJS())
      return loadedState;

    case PACKAGES_DATA.LOADING:
      return state.set("status", "loading");

    case PACKAGES_DATA.SUCCESS:
      return state.set("status", "loaded").set("packages", fromJS(action.data));

    case PACKAGES_DATA.FAILED:
      // If we already have a loaded state, then we don't overwrite what we have.
      if (state.get("status") === "loaded") return state;
      return state.set("status", "error");
    
    case UPDATE_JOB:
      // new job: merge packages and merge jobs.
      const updatedJobState = state
        .setIn(packagesPath, mergePackages(state.getIn(packagesPath), convertServerPackages([action.updatedJob])))
        .mergeIn(jobsPath, convertServerJobs([action.updatedJob]));

      console.log("[REDUCER] UPDATED JOB", action, state.toJS(), "====>", updatedJobState.toJS())
      return updatedJobState;

    case ADD_JOB:
      // new job: concat packages and merge jobs.
      const newJobState = state
        .setIn(packagesPath, state.getIn(packagesPath).concat(convertServerPackages([action.newJob])))
        .mergeIn(jobsPath, convertServerJobs([action.newJob]));

      console.log("[REDUCER] ADDED NEW JOB", action, state.toJS(), "====>", newJobState.toJS())
      return newJobState;

    case UPDATE_PACKAGES:
      const packages = state.getIn(["packages", action.warehouseId]);

      let originalState = null;
      let updatedState = null;

      // Mark as temporary as the server might reject those udpates
      const updateAndMarkAsTemp = (pack) => {
        // Keep track of original state
        if (originalState === null) {
          originalState = pack.get("state");
        }
        if (originalState !== pack.get("state")) {
          originalState = "discrepancies";
        }

        // Update the package
        const updatedPack = action.updater(pack).set("waitingForServerAck", !action.clientSideOnly);

        // Keep track of new state
        if (updatedState === null) {
          updatedState = updatedPack.get("state");
        }
        if (updatedState !== updatedPack.get("state")) {
          updatedState = "discrepancies";
        }

        return updatedPack;
      }
      // Update packages while we send the request to the server
      const updatedPackages = packages.map((p) => action.uids.includes(getPackageUID(p)) ? updateAndMarkAsTemp(p) : p);
      sendRequestToServer(action.uids, originalState, updatedState);

      return state.setIn(["packages", action.warehouseId], updatedPackages);
  
    default:
      return state;
  }
}

function convertServerJobs(serverJobs) {
  console.log("convertServerJobs(serverJobs)", serverJobs)
  // Keep job info in the state
  const stateJobs = serverJobs.reduce((acc, j) => {
    const nbPackages = j.packages.length;
    delete j.packages;
    acc[j.jobId] = j;
    acc[j.jobId].nbPackages = nbPackages;

    return acc;
  }, {});

  return fromJS(stateJobs);
}

function convertServerPackages(serverJobs) {
  console.log("convertServerPackages(serverJobs)", serverJobs)
  // Extract packages from jobs to save in the state
  const statePackages = serverJobs.flatMap((j) => j.packages.map((p) => ({
    ...p,
    id: p.packageId,
    jobId: j.jobId,
    waitingForServerAck: false, // reset client side waiting for ack
  })));

  return fromJS(statePackages);
}

function mergePackages(currentPackages, updatedPackages) {
  console.log("merge packages", currentPackages, updatedPackages)
  return currentPackages.map((p) => {
    const updated = updatedPackages.find(
      (up) => up.get("warehouseId") === p.get("warehouseId")
        && up.get("id") === p.get("id")
        && up.get("jobId") === p.get("jobId")
    );

    return updated ? updated : p;
  });
}


function sendRequestToServer(uuids, originalState, updatedState) {
  console.log("MUTATION", uuids.toJS ? uuids.toJS() : uuids, originalState, "=>", updatedState)

  if (originalState === "idle" && updatedState === "picking") {
    // 
  } else if (originalState === "picking" && updatedState === "packing") {
    // 
  } else if (originalState === "packing" && updatedState === "packed") {
    // 
  } else if (originalState === "packed" && updatedState === "loaded") {
    // 
  } else if (originalState === "loaded" && updatedState === "fulfilled") {
    // 
  }
}

export default reducer;